import { render } from "./CouponsPage.vue?vue&type=template&id=06515000&scoped=true"
import script from "./CouponsPage.vue?vue&type=script&lang=js"
export * from "./CouponsPage.vue?vue&type=script&lang=js"

import "./CouponsPage.vue?vue&type=style&index=0&id=06515000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06515000"]])

export default __exports__